module.exports = __webpack_public_path__ + "static/media/BarlowCondensed-BoldItalic.4d3b55fa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowCondensed-BoldItalic.ttf
// module id = 3005
// module chunks = 71